@if (shouldShow) {
  <app-clearance [clearance]="clearance" clearanceKey="sspi">
    @if (notRequired) {
      <div>Schip is niet ISPS plichtig</div>
    }
  </app-clearance>
}
